const isDanishPostalCode = /^\d{4}$/;

export const normalizeCitySearchQuery = (query?: string | null) =>
    String(query ?? '')
        .toLowerCase()
        .trim();

export const isValidDanishPostalCode = (query: string) =>
    isDanishPostalCode.test(normalizeCitySearchQuery(query));

export const isValidCitySearchQuery = (query: string) => normalizeCitySearchQuery(query).length > 0;
